import { store } from "../../../../../config/store";
import { filterData } from "../../../../../helpers/filterHelper";
import { showToastError, showMessageApi } from "../../../../Main/actions";
import { getAllCentrosAPI, getAllTerritories, getCentroAPI, deleteCentroAPI, createCentroAPI, updateCentroAPI, getPrestaciones } from "../../../../../services/mantenedoresSelApi";
import trace from "../../../../../helpers/trace";
import { listaBaterias } from "../../../../../services/solicitudesAgendaSelApi";
import { getAllPools } from "../../../../../services/poolsApi";

export const setListaTerritorios = (list) => ({
  type: "SET_LISTA_TERRITORIOS",
  list,
});

export const setFiltrosCentros = (filtros) => ({
  type: "SET_FILTROS_CENTROS",
  filtros,
});

export const setListaCentros = (data) => ({
  type: "SET_LISTA_CENTROS",
  data,
});

export const setListaCentrosFiltrados = (lista) => ({
  type: "SET_LISTA_CENTROS_FILTRADOS",
  lista,
});
export const loading = (isLoading) => ({
  type: "LOADING_MANTENEDOR_CENTROS",
  isLoading,
});

export const openCloseModalEditarCentro = (isOpen, centro, isNew) => ({
  type: "OPEN_CLOSE_MODAL_EDITAR_CENTRO",
  isOpen,
  centro,
  isNew,
});

export const setDataListasCentros = (Pools, AdditionalExams, PsychologicalExams) => ({
  type: "SET_DATA_LISTAS_CENTROS",
  Pools,
  AdditionalExams,
  PsychologicalExams,
});

export const setCentro = (centro) => ({
  type: "SET_CENTRO",
  centro,
});


export const openCloseModalEliminarCentro = (isOpen, centro) => ({
  type: "OPEN_CLOSE_MODAL_ELIMINAR_CENTRO",
  isOpen,
  centro,
});

export const openCloseModalDesactivarCentro = (isOpen, centro) => ({
  type: "OPEN_CLOSE_MODAL_DESACTIVAR_CENTRO",
  isOpen,
  centro,
});

export const resetStatus = () => ({
  type: "RESET_STATUS_MANTENEDOR_CENTROS",
});

export const resetStatusModal = () => ({
  type: "RESET_STATUS_MANTENEDOR_CENTROS_MODAL",
});

export const doGetFiltrosCentros = () => async (dispatch) => {
  dispatch(loading(true));
  try {
    let message;

    let territories = [];
    const request = await getAllTerritories();
    if (request.status === 200) {
      territories = await request.json();
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
    let baterias = [];
    const req = await getAllPools();
    if (req.status === 200) {
      baterias = await req.json();
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
    let prestaciones = [];
    let prestacionesAdicionales = [];
    let prestacionesCiel = [];
    const resp = await getPrestaciones();
    if (resp.status === 200) {
      prestaciones = await resp.json();
      prestacionesAdicionales = prestaciones.filter((e) => e.ExamTypeId === 1);
      prestacionesCiel = prestaciones.filter((e) => e.ExamTypeId === 2);
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }


    const filtros = [
      {
        column: "Status",
        name: "Activo",
        type: "bool",
        values: [
          { value: 1, text: "Si" },
          { value: 0, text: "No" },
        ],
      },
      {
        column: "Territory",
        name: "Territorio",
        values: territories.map((item) => ({ value: item.Description, text: item.Description })),
      },
      {
        column: "Days",
        name: "Día de atención",
        type: "date",
      },
      {
        column: "PoolDetail",
        name: "Baterías",
        values: baterias.map((item) => ({ value: item.Description, text: item.Description })),
      },
      {
        column: "ExamDetail",
        name: "Prestaciones SEP",
        values: prestacionesAdicionales.map((item) => ({ value: item.Description, text: item.Description })),
      },
      {
        column: "ExamCielDetail",
        name: "Prestaciones CIEL",
        values: prestacionesCiel.map((item) => ({ value: item.Description, text: item.Description })),
      },
    ];

    dispatch(setFiltrosCentros(filtros));
    dispatch(setListaTerritorios(territories));
  } catch (e) {
    trace.error("doGetFiltrosCentros", e);
    dispatch(showToastError());
  }
};

export const doGetListasCentros = () => async (dispatch) => {
  dispatch(loading(true));
  try {
    const request = await listaBaterias();
    const resultBaterias = await request.json();
    const Pools = resultBaterias && resultBaterias.Pools ? resultBaterias.Pools : [];
    const AdditionalExams = resultBaterias && resultBaterias.Exams ? resultBaterias.Exams.map((e) => e.ExamTypeId === 1 ? e : null).filter((f) => f) : [];
    const PsychologicalExams = resultBaterias && resultBaterias.Exams ? resultBaterias.Exams.map((e) => e.ExamTypeId === 2 ? e : null).filter((f) => f) : [];

    dispatch(setDataListasCentros(Pools, AdditionalExams, PsychologicalExams));
  } catch (e) {
    trace.error("doGetListasCentros", e);
    dispatch(showToastError(""));
  }
  dispatch(loading(false));
};

export const doGetCentroData = (centro) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const request = await getCentroAPI(centro.Id);
    let message;

    if (request.status === 200) {
      const result = await request.json();
      const data = { ...result };
      data.PoolsIds = result.Pools.map((pool) => pool.PoolId);
      data.AdditionalExamsIds = result.AdditionalExams.map((pool) => pool.ExamId);
      data.PsychologicalExamsIds = result.PsychologicalExams.map((pool) => pool.ExamId);
      const _activeHours = (daysArr, days) => {
        if (!days) return null;
        let _return = {};
        const _arr = days.filter((e) => daysArr.includes(e.DayId));
        if (_arr && _arr.length && _arr[0].Since !== null && _arr[0].Since !== undefined && _arr[0].Until !== null && _arr[0].Until !== undefined) {
          const _from = _arr[0].Since.length === 8 ? _arr[0].Since.slice(0, -3) : _arr[0].Since;
          const _to = _arr[0].Until.length === 8 ? _arr[0].Until.slice(0, -3) : _arr[0].Until;
          _return.text = `${_from} - ${_to}`;
          _return.value = {
            from: _from,
            to: _to,
          };
        } else {
          _return = null;
        }
        return _return;
      };

      data.horaSemana = _activeHours([1, 2, 3, 4, 5], data.Days);
      data.horaSabado = _activeHours([6], data.Days);
      data.horaDomingo = _activeHours([0], data.Days);

      dispatch(openCloseModalEditarCentro(true, data, false));
      dispatch(showMessageApi(message, request));
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
  } catch (e) {
    trace.error("doGetCentroData", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const doAddCentro = (newRow) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const _newRow = {};
    _newRow.Description = newRow.Description ? newRow.Description : null;
    _newRow.TerritoryId = newRow.TerritoryId ? newRow.TerritoryId : null;
    _newRow.Enabled = !!newRow.Active;
    _newRow.Code = newRow.Code ? newRow.Code : null;
    _newRow.Days = [];
    let weekDays = newRow.Days && newRow.Days.filter((e) => [1, 2, 3, 4, 5].includes(e.DayId));
    if (weekDays && weekDays.length) {
      weekDays = {
        Day: weekDays.map((e) => e.DayId),
        Since: weekDays[0].Since,
        Until: weekDays[0].Until,
      };
      _newRow.Days.push(weekDays);
    }
    let saturdayDay = newRow.Days && newRow.Days.filter((e) => e.DayId === 6);
    if (saturdayDay && saturdayDay.length) {
      saturdayDay = {
        Day: saturdayDay.map((e) => e.DayId),
        Since: saturdayDay[0].Since,
        Until: saturdayDay[0].Until,
      };
      _newRow.Days.push(saturdayDay);
    }

    let sundayDay = newRow.Days && newRow.Days.filter((e) => e.DayId === 0);
    if (sundayDay && sundayDay.length) {
      sundayDay = {
        Day: sundayDay.map((e) => e.DayId),
        Since: sundayDay[0].Since,
        Until: sundayDay[0].Until,
      };
      _newRow.Days.push(sundayDay);
    }

    _newRow.WorryingOverbook = !!newRow.WorryingOverbook;
    _newRow.WorryingOverbookedMaximumAmount = newRow.WorryingOverbookedMaximumAmount ? newRow.WorryingOverbookedMaximumAmount : null;
    _newRow.OccupationalOverbook = !!newRow.OccupationalOverbook;
    _newRow.OccupationalOverbookedMaximumAmount = newRow.OccupationalOverbookedMaximumAmount ? newRow.OccupationalOverbookedMaximumAmount : null;
    _newRow.CielOverbook = !!newRow.CielOverbook;
    _newRow.CielOverbookedMaximumAmount = newRow.CielOverbookedMaximumAmount ? newRow.CielOverbookedMaximumAmount : null;
    _newRow.Pools = newRow.PoolsIds && [...newRow.PoolsIds];
    _newRow.PsychologicalExams = newRow.PsychologicalExamsIds && [...newRow.PsychologicalExamsIds];
    _newRow.AdditionalExams = newRow.AdditionalExamsIds && [...newRow.AdditionalExamsIds];

    const request = await createCentroAPI(_newRow);
    let message;
    if (request.status === 200) {
      message = `Se ha agregado el centro ${newRow.Description}.`;
      dispatch(doGetCentros(null, true));
      dispatch(openCloseModalEditarCentro(false, {}, false));
      dispatch(showMessageApi(message, request));
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
  } catch (e) {
    trace.error("doAddCentro", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const doUpdateCentro = (editedRow, status) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const _editedRow = {};
    _editedRow.AchsOfficeId = editedRow.Id;
    _editedRow.Description = editedRow.Description ? editedRow.Description : null;
    _editedRow.TerritoryId = editedRow.TerritoryId ? editedRow.TerritoryId : null;
    _editedRow.Enabled = !!status;
    _editedRow.Code = editedRow.Code ? editedRow.Code : null;
    _editedRow.Days = [];
    _editedRow.RelationIdPsychologicalExamsDelete = editedRow.RelationIdPsychologicalExamsDelete ? editedRow.RelationIdPsychologicalExamsDelete : null;
    _editedRow.RelationIdAdditionalExamsDelete = editedRow.RelationIdAdditionalExamsDelete ? editedRow.RelationIdAdditionalExamsDelete : null;
    _editedRow.RelationIdPoolsDelete = editedRow.RelationIdPoolsDelete ? editedRow.RelationIdPoolsDelete : null;
    _editedRow.DaysDelete = editedRow.RelationIdDaysDelete ? editedRow.RelationIdDaysDelete.map((e) => e) : null;

    let weekDays = editedRow.newDays && editedRow.newDays.filter((e) => [1, 2, 3, 4, 5].includes(e.DayId));
    if (weekDays && weekDays.length) {
      weekDays = {
        Day: weekDays.map((e) => e.DayId),
        Since: weekDays[0].Since,
        Until: weekDays[0].Until,
      };
      _editedRow.Days.push(weekDays);
    }
    let saturdayDay = editedRow.newDays && editedRow.newDays.filter((e) => e.DayId === 6);
    if (saturdayDay && saturdayDay.length) {
      saturdayDay = {
        Day: saturdayDay.map((e) => e.DayId),
        Since: saturdayDay[0].Since,
        Until: saturdayDay[0].Until,
      };
      _editedRow.Days.push(saturdayDay);
    }

    let sundayDay = editedRow.newDays && editedRow.newDays.filter((e) => e.DayId === 0);
    if (sundayDay && sundayDay.length) {
      sundayDay = {
        Day: sundayDay.map((e) => e.DayId),
        Since: sundayDay[0].Since,
        Until: sundayDay[0].Until,
      };
      _editedRow.Days.push(sundayDay);
    }


    _editedRow.WorryingOverbook = !!editedRow.WorryingOverbook;
    _editedRow.WorryingOverbookedMaximumAmount = editedRow.WorryingOverbookedMaximumAmount ? editedRow.WorryingOverbookedMaximumAmount : null;
    _editedRow.OccupationalOverbook = !!editedRow.OccupationalOverbook;
    _editedRow.OccupationalOverbookedMaximumAmount = editedRow.OccupationalOverbookedMaximumAmount ? editedRow.OccupationalOverbookedMaximumAmount : null;
    _editedRow.CielOverbook = !!editedRow.CielOverbook;
    _editedRow.CielOverbookedMaximumAmount = editedRow.CielOverbookedMaximumAmount ? editedRow.CielOverbookedMaximumAmount : null;
    _editedRow.Pools = editedRow.newPoolsExams && [...editedRow.newPoolsExams];
    _editedRow.PsychologicalExams = editedRow.newPsychologicalExams && [...editedRow.newPsychologicalExams];
    _editedRow.AdditionalExams = editedRow.newAdditionalExamsExams && [...editedRow.newAdditionalExamsExams];

    const request = await updateCentroAPI(_editedRow);
    let message;
    if (request.status === 200) {
      message = `Se ha editado el centro ${_editedRow.Description}.`;
      dispatch(openCloseModalEditarCentro(false, {}, false));
      dispatch(openCloseModalDesactivarCentro(false, {}, false));
      dispatch(doGetCentros(null, true));
      dispatch(showMessageApi(message, request));
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
  } catch (e) {
    trace.error("doUpdateCentro", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const doGetCentros = (filtros, reload = false) => async (dispatch) => {
  if (!filtros) dispatch(loading(true));
  try {
    let data = store.getState().mantenedorCentros.listaCentros;
    if (reload) {
      data = [];
    }
    let message;

    if (!data.length) {
      const request = await getAllCentrosAPI();
      if (request.status === 200) {
        data = await request.json();
        dispatch(setListaCentros(data));
        dispatch(showMessageApi(message, request));
      } else {
        const result = await request.json();
        dispatch(showMessageApi(message, request, result));
      }
    }

    if (filtros) {
      const newData = filterData(data, filtros);
      dispatch(setListaCentrosFiltrados(newData));
    }
  } catch (e) {
    trace.error("doGetCentros", e);
    dispatch(showToastError());
  }
  if (!filtros) dispatch(loading(false));
};

export const doDeleteCentro = (centro) => async (dispatch) => {
  dispatch(loading(true));
  try {
    let message;

    const request = await deleteCentroAPI(centro.Id);
    if (request.status === 200) {
      message = `Se ha eliminado la el centro ${centro.Description}.`;
      dispatch(openCloseModalEliminarCentro(false, {}));
      dispatch(doGetCentros(null, true));
      dispatch(showMessageApi(message, request));
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
  } catch (e) {
    trace.error("doDeleteCentro", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};
